module.exports = __webpack_public_path__ + "img/solvit_logo.6715fd8c.png";